//Cms Sports Book

export const SPORTSBOOK_CLIENT_KEY = "6e6c1ebb9d611b2480b0050f0d360edd";
export const ENCRYPTION_PRIVATE_KEY =
  "8df234af7a1f14fa3cacf8733d5b236cd8afa0b4";
export const API_URL = "https://api.gastonbet365.com";
export const CONFIG = {
  BASE_URL: "https://api.gastonbet365.com",
  CMS_BASE_URL: "https://cmssport.cmswager.com/",
  CLIENT_KEY: "6e6c1ebb9d611b2480b0050f0d360edd",
  DEFAULT_LANG: "fr-FR",
};
